<div
  class="card w-100 p-0 d-print-inline-block"
  *ngIf="!hidden"
  [class.card-disabled]="!enabled"
  [ngClass]="{ hilite: hilite }"
>
  <div class="card-header p-0 pl-3 pr-2">
    <!-- Keep a flexible title column beside fixed actions, with roles below the wrapping title. -->
    <div class="row pb-0 flex-row flex-nowrap justify-content-between">
      <div
        class="approval-header-content p-3 d-flex flex-column align-items-start"
      >
        <h6 [innerHTML]="labelHtml | placeholderHighlight: editor"></h6>
        <div class="approval-roles d-flex align-items-center">
          <role-chips
            *ngIf="roleCodes || (userNames && !value)"
            [roleCodes]="roleCodes"
            [userNames]="userNames"
            [alignLeft]="true"
          ></role-chips>
        </div>
      </div>
      <div
        class="approval-actions d-flex p-1 pr-3 flex-column d-print-none justify-content-center"
      >
        <button
          mat-flat-button
          class="approval-button"
          *ngIf="showApprove || showUnapprove"
          [disabled]="disabled"
          [color]="color"
          (click)="click()"
          [matTooltip]="getTooltip(value ? 3 : 1)"
          [matTooltipPosition]="'right'"
          matTooltipClass="tooltip-class"
        >
          {{ label }}
        </button>
        <!-- Tester tool (non-production, System Administrators only): signs this approval as a
             role-holder. Rendered where Approve would be, and independent of `disabled` so it
             stays clickable even when the normal Approve button is greyed out. -->
        <button
          mat-stroked-button
          class="approval-button"
          *ngIf="showTestApprove"
          color="warn"
          type="button"
          (click)="testApprove.emit()"
          matTooltip="Tester tool (non-production): signs this approval as the first user with the required role, so you don't have to log in as that user."
          [matTooltipPosition]="'right'"
        >
          <mat-icon>auto_fix_high</mat-icon> Approve
        </button>
        <button
          mat-stroked-button
          class="approval-button"
          *ngIf="showDisapprove && !disabled"
          [disabled]="disabled"
          color="warn"
          (click)="disapproveEvent()"
          [matTooltip]="getTooltip(2)"
          [matTooltipPosition]="'right'"
          matTooltipClass="tooltip-class"
        >
          Disapprove
        </button>
      </div>
    </div>
  </div>
  <div class="card-body d-flex flex-column justify-content-center py-2">
    <div class="row">
      <div class="col-3 nowrap">By:</div>
      <div class="col-9">
        <span class="name" *ngIf="value">{{ name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <small class="nowrap">Date:</small>
      </div>
      <div class="col-9">
        <span
          class="date small"
          *ngIf="value"
          [ngStyle]="{ opacity: enabled ? 1 : 0.5 }"
          >{{ date | date: "medium" }}</span
        >
      </div>
    </div>
  </div>
</div>
